import { NavigationPathes } from 'shared/constants'

export const NAVBAR_MENU_TABS = [
  {
    sectionName: 'General',
    items: [
      {
        path: NavigationPathes.WITHDRAWALS,
        name: 'Profile',
        isActive: false
      }
    ]
  },
  {
    sectionName: 'Offchain',
    items: [
      {
        path: NavigationPathes.GAMES,
        name: 'Games',
        isActive: true
      },
      {
        path: NavigationPathes.OFFCHAIN_WITHDRAWALS,
        name: 'Withdrawals',
        isActive: true
      },
      {
        path: NavigationPathes.USER_ACCOUNTS,
        name: 'User Accounts',
        isActive: true
      },
      {
        path: NavigationPathes.REFERRAL_SEASONS,
        name: 'Ref. Seasons',
        isActive: true
      },
      {
        path: NavigationPathes.BONUS_TEMPLATES,
        name: 'Bonus Templates',
        isActive: true
      }
    ]
  },
  {
    sectionName: 'Finances',
    items: [
      {
        path: NavigationPathes.WITHDRAWALS,
        name: 'Ref. Withdrawals',
        isActive: true
      },
      {
        path: NavigationPathes.WITHDRAWALS_STATISTICS,
        name: 'Stats. Withdrawals',
        isActive: true
      },
      {
        path: NavigationPathes.CASHBACK_WITHDRAWALS,
        name: 'Cashback Withdrawals',
        isActive: true
      }
    ]
  },
  {
    sectionName: 'Users',
    items: [
      {
        path: NavigationPathes.WITHDRAWALS,
        name: 'Users',
        isActive: false
      },
      {
        path: NavigationPathes.WITHDRAWALS,
        name: 'Admins',
        isActive: false
      }
    ]
  }
]
